export const IdVerificationDataModeEnum = {
  liveness: 'liveness',
  auto: 'auto',
  expert: 'expert',
  certified: 'certified',
  default: 'default',
} as const;
export type IdVerificationDataModeEnum =
  (typeof IdVerificationDataModeEnum)[keyof typeof IdVerificationDataModeEnum];
